export default "__VITE_ASSET__BoBXndxB__"